(function ($) {
  const initializeBlock = function ($block) {
    if (!$($block.closest('.acf-block-preview')).length) {
      const $slider = $block.find('.carousel'),
      $buttons = $block.find('.customDots button');
      if ($slider.hasClass('slick-initialized'))
        $slider.slick('unslick');

      $slider.slick({
        arrows: false,
        dots: false,
        fade: true,
        mobileFirst: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        swipe: false,
        autoplay: true,
        autoplaySpeed: 10000,
        adaptiveHeight: true,
      });

      $block.find('.prev').click(function(){
        $slider.slick('slickPrev');
      });
      
      $block.find('.next').click(function(){
        $slider.slick('slickNext');
      });

      // Handling custom dots
      $buttons.on('click', function () {
        var slideIndex = $(this).data('slide');
        $slider.slick('slickGoTo', slideIndex);

        // Manage active state for the dots
        $buttons.removeClass('active');
        $(this).addClass('active');
      });

      // Set the initial active dot
      $buttons.first().addClass('active');

      // Update active dot on slide change
      $slider.on('beforeChange', function (event, slick, currentSlide) {
        currentSlide = currentSlide + 1
        if (currentSlide === slick.slideCount) {
          currentSlide = 0
        }
        $buttons.removeClass('active');
        $block.find('.customDots button[data-slide="' + currentSlide + '"]').addClass('active');
      });
    }
  }

  $(document).ready(function () {
    $('.block--testimonials-slider').each(function () {
      initializeBlock($(this));
    })
  })

  if (window.acf) {
    window.acf.addAction('render_block_preview/type=testimonials-slider', initializeBlock);
  }

})(jQuery);